import { Card, Row, Col } from "react-bootstrap";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { IconTextButton, TextButton } from 'Components/Button';
import { ICONS } from "Utils/icons";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { handleFileDownload } from 'Utils/utilityFunctions';
import { useDispatch } from 'react-redux';
import { setGlobalErrorStatus } from "../../../Components/StatusHandling";
import { ERROR_MESSAGES } from "../../../Utils/constants";

/**
 * 
 * @param {data} :
 * 
  {
    title: "",
    desc: "",
    numbers: [],
    links: {},
    moreDesc: []
  } 
 * @returns 
 */
//DOWNLOAD
const CommonFormatCard = ({ data }) => {

  const SCREEN_WIDTH_XL = 1277.5;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showMore, setShowMore] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [downloadingFiles, setDownloadingFiles] = useState([]);

  const handleShowMore = () => {
    setShowMore(!showMore);
  }

  const handleShowMoreOnKeyDown = (e) => {
    /** Key: Key Code
            Enter: 13; 
    */
    if (e.keyCode === 13) {
      setShowMore(!showMore);
    }
  }

  // get cols based on the length
  const getCols = (colData) => {
    if (colData?.length === 4) {
      return { sm: 6, lg: 3 };
    }

    return { sm: 6 };
  }

  /**download file */
  const downloadFile = (groupId) => {
    //console.log("downloadingFiles common format card", groupId);
    // avoid duplicate download
    if (downloadingFiles.includes(groupId)) {
      // do nothing
    }
    else {
      setDownloadingFiles([...downloadingFiles, groupId]);
      handleFileDownload(
        groupId,
        () => {
          setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
              visible: true,
              title: ERROR_MESSAGES.GENERAL_ERROR.title,
              msg: ERROR_MESSAGES.GENERAL_ERROR.message,
              showContactHelp: true
            },
            redirect: {
              redirect: false,
              redirectFirst: false,
              path: "",
              data: {}
            }
          })
        },
        () => {
          setDownloadingFiles(downloadingFiles.filter(f => f == groupId))
        }
      );
    }
  }

  // detect screen width change
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty dependency array ensures the effect runs only once on mount

  return (
    <>
      <Row className="justify-content-center common-format-card">
        <Col lg="9" xl="9">
          <Card>
            <Card.Body>
              <Card.Text>
                <Row className="m-2">
                  <Col className={screenWidth >= SCREEN_WIDTH_XL ? "text-start line-vertical-rule" : "text-start"} md={12} lg={12} xl={9}>
                    <div className="card-title mb-3">{data?.title}</div>
                    <div className="card-desc">{data?.desc}</div>
                    <Row className="mt-2">
                      {data?.numbers?.map((item, index) => {
                        return (
                          <Col {...getCols(data?.numbers)} className="text-center mt-3 mb-3">
                            <div>
                              <div key={index + "-" + item.val} className="type-number">{item.number}</div>
                              <div key={index + "-" + item.desc}>{item.desc}</div>
                            </div>
                          </Col>
                        )
                      })}
                    </Row>
                    {showMore ? data?.moreDesc?.map((item, index) => {
                      return (
                        <Row className="mt-4">
                          <Col className="text-start">
                            {item}
                          </Col>
                        </Row>
                      )
                    }) : null}
                  </Col>
                  <Col className="m-3">
                    <TextButton variant="normal"
                      content="Learn about the Format"
                      onClick={() => navigate(data?.links?.learnMore)}
                      className="w-100 mb-4"
                    />
                    {/* <IconTextButton
                      className="reverse button-width text-center w-100 d-flex justify-content-center mb-4"
                      icon={ICONS.download}
                      onClick={() => downloadFile(data?.links?.downloadAllResources)}
                      variant="normal"
                      content={"Download All Resources"}
                    /> */}
                    <IconTextButton
                        className="reverse button-width text-center w-100 d-flex justify-content-center mb-4"
                        icon={ICONS.download}
                        //onClick={handleAllFileDownload}
                        variant="normal"
                        content={"Download all Resources"}
                        groupId={data?.links?.downloadAllResources}
                    />
                    {/* Comment below since Comment Tool is not ready
                    <div className="feedback-link">
                      Share Feedback
                    </div> 
                    */}
                  </Col>
                </Row>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col >
      </Row >
      <Row
        className="justify-content-center common-format-card-toggle"
      >
        {showMore ?
          <Col lg="9" xl="9" className="mb-5">
            <Card
              onClick={handleShowMore}
              tabIndex={0}
              onKeyDown={handleShowMoreOnKeyDown}
            >
              <Card.Body>
                <Card.Text>
                  Show Less&nbsp;<ArrowDropUpIcon></ArrowDropUpIcon>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col> :
          <Col lg="9" xl="9" className="mb-5">
            <Card
              onClick={handleShowMore}
              tabIndex={0}
              onKeyDown={handleShowMoreOnKeyDown}
            >
              <Card.Body>
                <Card.Text>
                  Show More&nbsp;<ArrowDropDownIcon></ArrowDropDownIcon>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        }
      </Row>
    </>
  )
}

export default CommonFormatCard;